import { ComponentProps } from "react"

import { twMerge } from "tailwind-merge"

import style from "./Select.module.scss"
import { FieldError } from "~/src/components/FieldError"

export interface SelectError {
  message?: string
}

export type SelectOption = {
  value: string
  label: string
}

export type SelectProps = { error?: SelectError | boolean; options: SelectOption[] } & ComponentProps<"select">

export function Select(props: SelectProps) {
  const { className, options, error, ...restProps } = props

  let errorMessage: string | undefined

  if (typeof error != "boolean") {
    errorMessage = error?.message
  }

  return (
    <div className={twMerge([style.base, error && style.hasError])}>
      <select className={twMerge([className])} {...restProps}>
        {options.map(({ value, label }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      {errorMessage && <FieldError className={style.fieldError} message={errorMessage} />}
    </div>
  )
}
